import React from 'react';
import useCustomerTypes from '../components/hooks/useCustomerTypes';
import { CustomerContext, CustomerState } from './CustomerContext';

type CustomerProviderProps = {
    children: React.ReactNode;
    initialState?: CustomerState;
};

const CustomerProvider = ({
    children,
    initialState
}: CustomerProviderProps): JSX.Element => {
    const { customer, setCustomer } = useCustomerTypes(initialState);

    return (
        <CustomerContext.Provider
            value={{
                customer,
                setCustomer
            }}>
            {children}
        </CustomerContext.Provider>
    );
};

export default CustomerProvider;
